export default "__VITE_ASSET__$9bfLmHX__"